

const state = {
  parameters: {
    brandName: null,
    left: 50,
    right: 50,
    top: 50,
    bottom: 0,
    qrSize: 120,
    fontSize: 12,
    headerFontSize: 12,
    footerFontSize: 8,
    cols: 2,
    optionalFields: []
  },
  loading: false
};

const mutations = {
  setParameters(state, params) {
    state.parameters = params;
  },
  setLoading(state, status) {
    state.loading = status;
  }
};

const actions = {
  updateParameters({commit}, params) {
    commit('setParameters', params);
  },
};

const getters = {
  parameters: state => {
    return state.parameters;
  },
  isLoading: state => {
    return state.loading;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
